export default __webpack_public_path__ + "static/media/107_mobile.dc4c321d.jpg";